export default {
  // Hero Section
  'hero.title.invest': 'Đầu Tư - Định Cư',
  'hero.title.card': 'Nhận Thẻ Tạm Trú Châu Âu',
  'hero.description': 'Đầu tư vào siêu thị Asian Alley - Nhận thẻ tạm trú Latvia trong 4-6 tháng cho cả gia đình',
  'hero.cta.consult': 'Đăng Ký Tư Vấn',
  'hero.cta.learnMore': 'Tìm Hiểu Thêm',
  'hero.stat1.title': '4-6 Tháng',
  'hero.stat1.desc': 'Thời gian xử lý hồ sơ nhanh chóng',
  'hero.stat2.title': 'Cả Gia Đình',
  'hero.stat2.desc': 'Vợ chồng và con dưới 18 tuổi',
  'hero.stat3.title': 'An Toàn',
  'hero.stat3.desc': 'Mô hình kinh doanh đã chứng thực',

  // Benefits Section
  'benefits.title': 'Lợi Ích Vượt Trội',
  'benefits.description': 'Định cư Latvia mang đến cho Bạn và Gia đình những cơ hội phát triển toàn diện',
  'benefits.1.title': 'Thẻ Tạm Trú Châu Âu',
  'benefits.1.desc': 'Nhận thẻ tạm trú Latvia, tự do đi lại trong 26 quốc gia Schengen',
  'benefits.2.title': 'Giáo Dục Chất Lượng Cao',
  'benefits.2.desc': 'Con em được tiếp cận hệ thống giáo dục châu Âu tiên tiến với miễn phí học phí khi định cư.',
  'benefits.3.title': 'Y Tế Hiện Đại',
  'benefits.3.desc': 'Hưởng hệ thống y tế châu Âu với chi phí hợp lý và chất lượng dịch vụ cao',
  'benefits.4.title': 'An Toàn & Ổn Định',
  'benefits.4.desc': 'Latvia là quốc gia thành viên EU và NATO với môi trường sống an toàn, ổn định',
  'benefits.5.title': 'Định Cư An Toàn',
  'benefits.5.desc': 'Mô hình kinh doanh đã được chứng thực, bảo đảm an toàn thẻ cho gia đình trong suốt 5 năm định cư',
  'benefits.6.title': 'Cơ Hội Làm Việc',
  'benefits.6.desc': 'Tham gia làm việc ngay chính tại các cửa hàng Asian Alley trong hệ thống',

  // Process Section
  'process.title': 'Quy Trình Thực Hiện',
  'process.description': '6 bước đơn giản để hoàn tất hồ sơ định cư Latvia trong 4-6 tháng',
  'process.step1.title': 'Tư Vấn & Đánh Giá',
  'process.step1.desc': 'Chuyên viên của chúng tôi sẽ tư vấn chi tiết về chương trình và đánh giá hồ sơ của bạn',
  'process.step2.title': 'Chuẩn Bị Hồ Sơ',
  'process.step2.desc': 'Hỗ trợ chuẩn bị đầy đủ hồ sơ pháp lý và tài liệu cần thiết theo yêu cầu',
  'process.step3.title': 'Ký Hợp Đồng Đầu Tư',
  'process.step3.desc': 'Ký kết hợp đồng đầu tư vào siêu thị Asian Alley với điều khoản rõ ràng, minh bạch',
  'process.step4.title': 'Nộp Hồ Sơ',
  'process.step4.desc': 'Nộp hồ sơ xin thẻ thường trú tại cơ quan di trú Latvia',
  'process.step5.title': 'Phỏng Vấn & Xét Duyệt',
  'process.step5.desc': 'Hỗ trợ chuẩn bị phỏng vấn và theo dõi quá trình xét duyệt hồ sơ',
  'process.step6.title': 'Nhận Thẻ Tạm Trú',
  'process.step6.desc': 'Nhận thẻ tạm trú Latvia cho cả gia đình',
  'process.note': 'Thời gian xử lý:',
  'process.noteTime': '4-6 tháng kể từ khi nộp hồ sơ đầy đủ',

  // Packages Section
  'packages.badge': 'Chi phí minh bạch',
  'packages.title': 'Chi Phí Dịch Vụ Tư Vấn Hồ Sơ & Định Cư',
  'packages.description': 'Tổng quan chi phí dịch vụ định cư Latvia — minh bạch, rõ ràng, không phát sinh',
  'packages.common.title': 'Chi Phí Chung',
  'packages.excluded.title': 'Không Bao Gồm',
  'packages.cost1.label': 'Phí tham gia chương trình',
  'packages.cost1.amount': 'từ 60,000 EUR/ Hồ Sơ Dịch Vụ',
  'packages.cost2.label': '',
  'packages.cost2.amount': '',
  'packages.excluded1': 'Vé máy bay',
  'packages.excluded2': 'Chi phí VISA',
  'packages.excluded3': 'Các chi phí khác phát sinh trong thời gian làm thủ tục nhưng không bao gồm trong hợp đồng',
  'packages.note': 'Cam kết minh bạch chi phí — Không phát sinh ngoài hợp đồng',

  // FAQ Section
  'faq.title': 'Câu Hỏi Thường Gặp',
  'faq.description': 'Giải đáp những thắc mắc phổ biến về chương trình định cư Latvia',
  'faq.q1': 'Vì sao nên chọn định cư Latvia?',
  'faq.a1': 'Latvia là quốc gia thuộc Liên minh Châu Âu (EU) và khối Schengen, khi có thẻ cư trú Latvia, Quý khách sẽ nhận được: Tự do đi lại 29 quốc gia Schengen. Quyền sinh sống hợp pháp tại Châu Âu. Cơ hội cho con học tập tại EU với chi phí thấp. Cơ hội mở rộng kinh doanh tại thị trường Châu Âu. Chi phí đầu tư thấp so với các chương trình định cư EU khác.',
  'faq.q2': 'Khoản đầu tư 50.000 EUR có bị mất không?',
  'faq.a2': 'Khoản 50.000 EUR là khoản tham gia vào chương trình để đủ điều kiện xin thẻ cư trú tạm thời Latvia theo quy định của Chính phủ. Mục tiêu chính của khoản này là giúp Quý khách và gia đình nhận được quyền cư trú hợp pháp tại Châu Âu. Sau thời gian duy trì tối thiểu 5 năm, tùy theo tình hình hoạt động và điều kiện chương trình tại thời điểm đó, Quý khách có thể được hoàn lại khoảng 10.000 – 15.000 EUR. Phần chi phí còn lại được xem như chi phí tham gia chương trình và duy trì điều kiện cư trú, tương tự như các chương trình định cư khác tại Châu Âu.',
  'faq.q3': 'Sau bao lâu tôi nhận được thẻ cư trú?',
  'faq.a3': 'Thông thường thời gian xử lý: 6 – 12 tháng kể từ khi hoàn tất hồ sơ và đầu tư. Với gói VIP, hồ sơ được ưu tiên xử lý nhanh hơn.',
  'faq.q4': 'Tôi có cần sống ở Latvia không?',
  'faq.a4': 'Không bắt buộc phải sống toàn thời gian tại Latvia. Quý khách vẫn có thể: Sinh sống tại Việt Nam, Đi lại Châu Âu khi cần, Duy trì thẻ cư trú hợp pháp. Chương trình rất phù hợp với: Chủ doanh nghiệp; Nhà đầu tư; Người muốn có "quyền cư trú Châu Âu dự phòng".',
  'faq.q5': 'Gia đình tôi có thể đi cùng không?',
  'faq.a5': 'Có. Chương trình cho phép bao gồm: Vợ / chồng, Con cái phụ thuộc. Cả gia đình đều được cấp thẻ cư trú Latvia cùng lúc.',
  'faq.q6': 'Tôi nhận được gì sau khi định cư Latvia?',
  'faq.a6': 'Quý khách sẽ nhận: Thẻ cư trú Latvia, Quyền sống tại Châu Âu, Tự do đi lại Schengen, Cơ hội cho con học tập tại EU, Nền tảng để mở rộng kinh doanh quốc tế. Đây là bước đệm quan trọng để trở thành công dân Châu Âu trong tương lai.',
  'faq.q7': 'Công ty có hỗ trợ việc làm khi tôi đến Latvia không?',
  'faq.a7': 'Sau khi sang Latvia, tùy theo khả năng, công ty sẽ hỗ trợ giới thiệu việc làm tại các cty/ xí nghiệp hoặc làm việc trực tiếp tại siêu thị Asian Alley.',
  'faq.q8': 'Vì sao nên làm ngay bây giờ?',
  'faq.a8': 'Các chương trình định cư EU thường: Tăng chi phí theo thời gian; Thay đổi chính sách; Siết chặt điều kiện. Hiện tại, Latvia vẫn là chương trình: Chi phí thấp; Điều kiện đơn giản; Tỷ lệ thành công cao. Làm sớm sẽ tiết kiệm chi phí và đảm bảo cơ hội.',
  'faq.q9': 'Vì sao chương trình lựa chọn đầu tư vào Asian Alley?',
  'faq.a9': 'Asian Alley là siêu thị Châu Á do người Việt làm chủ tại Latvia, đã hoạt động nhiều năm và có nền tảng kinh doanh ổn định. 1. Chủ doanh nghiệp là người Việt – dễ hỗ trợ, Hiểu rõ nhu cầu và tâm lý khách hàng Việt, Dễ trao đổi, hỗ trợ và xử lý khi cần thiết. 2. Doanh nghiệp đang hoạt động thực tế và ổn định. Siêu thị đang kinh doanh thực, không phải công ty mở ra chỉ để làm hồ sơ. Có lượng khách hàng ổn định tại Latvia. Có lịch sử hoạt động rõ ràng. Điều này đảm bảo chương trình hợp pháp và an toàn. 3. Đảm bảo điều kiện cấp thẻ cư trú Latvia, Mục tiêu chính của khoản đầu tư là: Đáp ứng điều kiện chương trình cư trú, Giúp khách hàng nhận thẻ tạm trú Latvia hợp pháp, Duy trì thẻ trong thời gian dài. Asian Alley đáp ứng đầy đủ điều kiện pháp lý này.',

  // Stats Section
  'stats.title': 'Con Số Ấn Tượng',
  'stats.description': 'Những thành tựu đáng tự hào của chúng tôi trong lĩnh vực định cư Latvia',
  'stats.1.number': '500+',
  'stats.1.label': 'Khách Hàng Tin Tưởng',
  'stats.2.number': '98%',
  'stats.2.label': 'Tỷ Lệ Thành Công',
  'stats.3.number': '4-6',
  'stats.3.label': 'Tháng Xử Lý Hồ Sơ',
  'stats.4.number': '5+',
  'stats.4.label': 'Năm Kinh Nghiệm',
  'stats.asian.title': 'SIÊU THỊ CHÂU Á ASIAN ALLEY TẠI LATVIA',
  'stats.asian.location': '2 cơ sở tại trung tâm Riga, Latvia',
  'stats.asian.revenue': 'Doanh thu hàng năm',

  // CTA Section
  'cta.title': 'Bắt Đầu Hành Trình Định Cư Của Bạn',
  'cta.description': 'Đừng bỏ lỡ cơ hội vàng để sở hữu thẻ thường trú châu Âu. Đội ngũ chuyên gia của chúng tôi sẵn sàng tư vấn miễn phí và đồng hành cùng bạn trong suốt hành trình định cư.',
  'cta.button.consult': 'Đăng Ký Tư Vấn',
  'cta.button.call': 'Gọi Ngay',

  // Detail Hero Section
  'detail.hero.badge': 'Cửa ngõ châu Âu',
  'detail.hero.title': 'Định Cư Latvia',
  'detail.hero.titleSub': '- Cơ Hội Định Cư Châu Âu',
  'detail.hero.description': 'Latvia - Cửa ngõ vàng để sở hữu thẻ tạm trú châu Âu với chi phí hợp lý và quy trình nhanh chóng. Đầu tư định cư Latvia chỉ từ 50.000 EUR.',

  // Why Latvia Section
  'detail.why.title': 'Tại Sao Chọn',
  'detail.why.titleBold': 'Định Cư Latvia',
  'detail.why.p1': 'Latvia là quốc gia thành viên Liên minh châu Âu và khu vực Schengen, nằm ở vị trí chiến lược tại Đông Bắc châu Âu. Với chính sách định cư thông qua đầu tư linh hoạt, Latvia đang trở thành điểm đến hấp dẫn cho nhiều gia đình Việt Nam muốn định cư châu Âu.',
  'detail.why.p2': 'Chương trình đầu tư định cư Latvia cho phép bạn và gia đình nhận thẻ tạm trú chỉ trong 4-6 tháng thông qua việc đầu tư vào doanh nghiệp địa phương như siêu thị Asian Alley. Chi phí định cư Latvia hợp lý, quy trình minh bạch.',
  'detail.why.stat1': 'Quốc gia Schengen',
  'detail.why.stat2': 'Dân số',

  // Requirements Section
  'detail.requirements.title': 'Điều Kiện',
  'detail.requirements.titleBold': 'Đầu Tư Định Cư Latvia',
  'detail.requirements.description': 'Yêu cầu đơn giản và dễ đáp ứng cho hầu hết các gia đình Việt Nam muốn định cư Latvia',
  'detail.requirements.1.title': 'Độ Tuổi',
  'detail.requirements.1.desc': 'Từ 18 tuổi trở lên, không giới hạn độ tuổi tối đa',
  'detail.requirements.2.title': 'Lý Lịch Sạch',
  'detail.requirements.2.desc': 'Không có tiền án tiền sự, lý lịch tư pháp trong sạch',
  'detail.requirements.3.title': 'Năng Lực Tài Chính',
  'detail.requirements.3.desc': 'Có khả năng đầu tư từ €50,000 trở lên',
  'detail.requirements.4.title': 'Hồ Sơ Đầy Đủ',
  'detail.requirements.4.desc': 'Chuẩn bị đầy đủ giấy tờ theo yêu cầu của cơ quan di trú',

  // Asian Alley Invest Section
  'detail.asian.title': 'Đầu Tư Vào Asian Alley',
  'detail.asian.titleSub': '- Con Đường Định Cư Latvia',
  'detail.asian.description': 'Asian Alley là chuỗi siêu thị châu Á hàng đầu tại Latvia với 2 cơ sở tại trung tâm thành phố Riga. Siêu thị chuyên cung cấp thực phẩm và hàng hóa châu Á chất lượng cao, phục vụ cộng đồng người châu Á ngày càng đông đảo tại Latvia.',
  'detail.asian.location.label': 'Vị trí:',
  'detail.asian.location.value': '2 cơ sở tại trung tâm Riga, Latvia',
  'detail.asian.revenue.label': 'Doanh thu:',
  'detail.asian.revenue.value': 'Hơn €500,000/năm và đang tăng trưởng',
  'detail.asian.customers.label': 'Khách hàng:',
  'detail.asian.customers.value': 'Phục vụ hàng nghìn khách hàng mỗi tháng',
  'detail.asian.button': 'Tìm Hiểu Chi Tiết',

  // Benefits Detail Section
  'detail.benefits.title': 'Quyền Lợi',
  'detail.benefits.titleSub': 'Thẻ Tạm Trú Latvia',
  'detail.benefits.description': 'Những lợi ích thiết thực khi sở hữu thẻ tạm trú Latvia và định cư châu Âu',
  'detail.benefits.1': 'Tự do đi lại trong 26 quốc gia Schengen',
  'detail.benefits.2': 'Quyền cư trú và làm việc tại Latvia',
  'detail.benefits.3': 'Con em được học tập miễn phí',
  'detail.benefits.4': 'Hưởng hệ thống y tế châu Âu',
  'detail.benefits.5': 'Sau 10 năm có thể xin quốc tịch Latvia',
  'detail.benefits.6': 'Môi trường sống an toàn, văn minh',
  'detail.benefits.7': 'Chi phí sinh hoạt hợp lý',
  'detail.benefits.8': 'Cộng đồng người Việt mở rộng',
  'detail.benefits.button': 'Đăng Ký Tư Vấn',

  // Investment Usage Section
  'detail.usage.title': 'Chúng Tôi Làm Gì Với Khoản',
  'detail.usage.titleBold': 'Đầu Tư Định Cư Latvia',
  'detail.usage.titleEnd': 'Của Bạn?',
  'detail.usage.description': 'Khoản đầu tư của bạn được sử dụng minh bạch và hiệu quả để phát triển hệ thống Asian Alley',
  'detail.usage.1.title': 'Mở Rộng Siêu Thị',
  'detail.usage.1.desc': 'Đầu tư mở rộng chuỗi siêu thị Asian Alley tại Latvia và khu vực Baltic, tăng số lượng cơ sở và quy mô kinh doanh',
  'detail.usage.2.title': 'Mở Rộng Sản Phẩm',
  'detail.usage.2.desc': 'Đa dạng hóa danh mục sản phẩm châu Á chất lượng cao, đáp ứng nhu cầu ngày càng tăng của cộng đồng',
  'detail.usage.3.title': 'Nâng Cấp Logistics',
  'detail.usage.3.desc': 'Đầu tư vào hệ thống kho bãi, vận chuyển và quản lý chuỗi cung ứng hiện đại, đảm bảo hàng hóa luôn tươi mới',
  'detail.usage.4.title': 'Phát Triển Nhân Sự',
  'detail.usage.4.desc': 'Tuyển dụng và đào tạo đội ngũ nhân viên chuyên nghiệp, tạo cơ hội việc làm cho cộng đồng người Việt tại Latvia',
  'detail.usage.commitment.title': 'Cam Kết Minh Bạch',
  'detail.usage.commitment.desc': 'Mọi khoản đầu tư đều được sử dụng cho mục đích phát triển kinh doanh thực tế của Asian Alley. Chúng tôi cam kết minh bạch tình hình hoạt động và sử dụng vốn, đảm bảo quyền lợi cho các nhà đầu tư định cư Latvia.',

  // Blog Preview Section
  'detail.blog.title': 'Tin Tức & Cẩm Nang',
  'detail.blog.titleBold': 'Định Cư Latvia',
  'detail.blog.description': 'Cập nhật thông tin mới nhất về chính sách và kinh nghiệm định cư',
  'detail.blog.viewAll': 'Xem tất cả',
  'detail.blog.viewAllMobile': 'Xem tất cả bài viết',

  // Page Meta
  'meta.latvia.title': 'Định Cư Latvia 2025 - Điều Kiện, Quy Trình & Chi Phí Đầu Tư | The Daeg International',
  'meta.latvia.description': 'Hướng dẫn chi tiết về định cư Latvia 2025: Điều kiện đầu tư từ 50.000 EUR, quy trình 4-6 tháng, quyền lợi thẻ tạm trú Schengen. Đầu tư vào Asian Alley - chuỗi siêu thị châu Á hàng đầu tại Riga, Latvia. Tư vấn miễn phí cho người Việt Nam.',
  'meta.latvia.keywords': 'định cư Latvia 2025, điều kiện định cư Latvia, chi phí định cư Latvia, quy trình định cư Latvia, đầu tư Asian Alley, thẻ tạm trú Schengen, định cư Riga, quyền lợi định cư Latvia, di trú châu Âu',
  'meta.detail.title': 'Chi Tiết Định Cư Latvia - Điều Kiện, Quyền Lợi & Đầu Tư | The Daeg International',
  'meta.detail.description': 'Thông tin chi tiết về định cư Latvia: Tại sao chọn Latvia, điều kiện đầu tư từ 50.000 EUR, quyền lợi thẻ tạm trú Schengen, đầu tư vào Asian Alley. Tư vấn miễn phí cho người Việt Nam.',
  'meta.detail.keywords': 'chi tiết định cư Latvia, điều kiện định cư Latvia, quyền lợi thẻ tạm trú, đầu tư Asian Alley, định cư châu Âu, thẻ Schengen',
};